import React, { Component } from 'react';
import _, { isEmpty, get } from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';
import Select from '../../../../components/FormElements/Select';
import { handleFieldError, initializeForm } from '../../../../utils/form-validation';
import {
  formFields, platformtype, accountOptions
} from './constant';
import { createAdvertiserAction, getAdvertisersWithoutAccounts, updateAdvertiserAction, getEditListAdvertiserAction,getGenrateAccountIdDV360Action } from '../../../../actions';
import { sortArray } from '../../../../selectors';
import CheckboxGroup from '../../../../components/FormElements/CheckboxGroup';
import "../io.scss"
import ToastModal from "../../../../components/ToastModal";
import { array } from 'prop-types';

import Google from "./Google/Manual";
// import GooglePlatformLogin from "./Google/PlatformLogin";

import Facebook from "./Facebook/Manual";
// import FacebookPlatformLogin from "./Facebook/PlatformLogin";

import FacebookSignIn from "./Facebook";
import GoogleSignIn from "./Google";

import ION from "./ION/Manual";
import IONPlatformLogin from "./ION/PlatformLogin";
import Dv360SignIn from "./DV360";

import DV360 from "./DV360/Manual";
import Dv360PlatformLogin from "./DV360/PlatformLogin";

import Gam from "./GAM/Manual";
import GamPlatformLogin from "./GAM/PlatformLogin";

import TiktokLogin from "./Tiktok";

import RadioBtn from "../../../../components/RadioBtn";
import { components } from "react-select";

import { handleError } from "../../../../utils/form-validation";


const Spinner = asyncRoute(()=> import('../../../../components/Spinner'));
const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      touched: {},
      errors: {},
      form: {},
      touched: {},
      errors: {},
      editMode: false,
      submited: false,
      selectedPlatform: [],
      checkFields: "",
      googleCheck: [],
      facebookCheck: [],
      ionCheck: [],
      dv360Check: [],
      selectedPlatformObj: {},
      loginStatus: false,
      syncId: "",
      redirectPage: false,
      isRedirectToList:false,
      isAccountDV360: null,
      showSpinner:false
    };

    platformtype.forEach(item => {
      item.checked = false;
    })

  }

  async componentWillMount() {
    const { tenantId, authToken, userId, getIoAdvertisersReportAction, configurationList, match: { params: { id } }, history } = this.props;

    let editId = JSON.parse(localStorage.getItem("editId"));
    if (history.location.state) {
      this.setState({ syncId: history.location.state })
    }

    let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    let loginClicked = JSON.parse(localStorage.getItem("loginClicked"));

    if (isEmpty(isAuthenticated)) {
      const { history } = this.props;
      history.push(routes.preSignIn);
    }

    if (loginClicked == null) {
      localStorage.removeItem("advertiserPlatform");
      localStorage.removeItem("addType");
      // localStorage.removeItem("advertiserId");
    }
    const { form, errors } = initializeForm(formFields);

    form.platform = platformtype;
    form.addTypeIon = "0";

    // this.setState({ form, errors }, async() => {
    //   // this.handleSyncCampaign();
    //   if (editId) {
    //     this.editId(editId);
    //   }
    // });

    // this.setState({ form, errors });


    // this.selectedCheckbox();

    // this.advertiserAccounts();


    this.setState({ form, errors }, async() => {
      // this.handleSyncCampaign();
      if (editId) {
       await this.editId(editId);
      }
      else{
        const { match: { params: id }, history } = this.props;
        history.push('/' + routes.mainRoute + '/' + routes.containers.admin + '/' + routes.admin.advertiser.newAdvertiser);
      }
      await this.selectedCheckbox();
  
      this.advertiserAccounts();
    });
    // this.setState({ form, errors })
  }

  // getAdvertisersWithoutAccounts
  advertiserAccounts = async () => {
    const { tenantId, authToken, userId, getAdvertisersWithoutAccounts } = this.props;
    const {
      responseCode: { status = "" },
      responseList,
    } = await getAdvertisersWithoutAccounts({ tenantId, authToken, userId });
    if (status === "Success") {
      this.setState({ advetiderListData: responseList });
    }
  }

  // ====== on change function =======
  handleChange = (e, index) => {
    let { form } = this.state;
    let { value, name } = e.target;
    form[name] = value;
    this.setState({ form });

    if (name == "advertiserId") {
      localStorage.setItem("advertiserId", JSON.stringify(value));
    } else if (name === "platform") {
      var arr = [];
      form.platform.filter(item => item.checked === true ? arr.push(item.value) : "");
      localStorage.setItem("advertiserPlatform", JSON.stringify(form.platform));
      this.setState({ selectedPlatform: arr })

    } else if(name == "addTypeDv360"){
      let obj = {
        addTypeDv360: value
      }
      localStorage.setItem("addType", JSON.stringify(obj));
    }
  }

  selectedCheckbox = async () => {
    const { form, platformButton } = this.state;
    let selectedAdvertiser = JSON.parse(localStorage.getItem("advertiserPlatform"));
    let addType = JSON.parse(localStorage.getItem("addType"));
    // debugger;
    if (selectedAdvertiser != null) {
      platformtype.forEach(item => {
        selectedAdvertiser.forEach(element => {
          if (item.value == element.value && element.checked === true) {
            item.checked = true;
            // item.disabledBtn = false;
          }
        })
      })

      let arr = [];
      platformtype.filter(item => item.checked === true ? arr.push(item.value) : "");
      form.platform = arr;
      this.setState({ selectedPlatform: arr, form })
    }
    if (addType) {
      form.addTypeDv360 = addType.addTypeDv360
    }
    this.setState({ form })
  }

  handleTouch = (e) => {
    let { touched, form, errors } = this.state;
    let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };

  handleSubmit = async (e) => {
    const { form, googleCheck, ionCheck, dv360Check, facebookCheck, errors } = this.state;
    e.preventDefault();
    this.setState({ checkFields: Math.random() }, () => {
      const platformsFilter = platformtype.filter(item => item.checked === true);
      var platforms = [];
      platformsFilter.forEach(ele => {
        platforms.push(ele.value);
      })

      let { errors } = handleError(form, formFields);

      if (platforms.length > 0) {
        if (platforms.length === 4) {
          if ((googleCheck.length > 0) && (facebookCheck.length > 0) && (dv360Check.length > 0) && (ionCheck.length > 0)) {
            this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
          } else {
            this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
          }
        } else if (platforms.length === 3) {
          if (platforms[0] === "Google Adwords" && platforms[1] === "Facebook" && platforms[2] === "ION") {
            if ((googleCheck.length > 0) && (facebookCheck.length > 0) && (ionCheck.length > 0)) {
              this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
            } else {
              this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
            }
          }

          if (platforms[0] === "Google Adwords" && platforms[1] === "Facebook" && platforms[2] === "DV 360") {
            if ((googleCheck.length > 0) && (facebookCheck.length > 0) && (dv360Check.length > 0)) {
              this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
            } else {
              this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
            }
          }

          if (platforms[0] === "Google Adwords" && platforms[2] === "DV 360" && platforms[1] === "ION") {
            if ((googleCheck.length > 0) && (dv360Check.length > 0) && (ionCheck.length > 0)) {
              this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
            } else {
              this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
            }
          }


          if (platforms[0] === "Facebook" && platforms[2] === "DV 360" && platforms[1] === "ION") {
            if ((facebookCheck.length > 0) && (dv360Check.length > 0) && (ionCheck.length > 0)) {
              this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
            } else {
              this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
            }
          }
        } else if (platforms.length === 2) {
          if (platforms[0] == "Google Adwords" && platforms[1] == "Facebook") {
            if ((googleCheck.length > 0) && (facebookCheck.length > 0)) {
              this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
            } else {
              this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
            }
          }

          if (platforms[0] === "Google Adwords" && platforms[1] === "ION") {
            if ((googleCheck.length > 0) && (ionCheck.length > 0)) {
              this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
            } else {
              this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
            }
          }

          if (platforms[0] === "Google Adwords" && platforms[1] === "DV 360") {
            if ((googleCheck.length > 0) && (dv360Check.length > 0)) {
              this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
            } else {
              this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
            }
          }

          if (platforms[0] === "Facebook" && platforms[1] === "ION") {
            if ((facebookCheck.length > 0) && (ionCheck.length > 0)) {
              this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
            } else {
              this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
            }
          }

          if (platforms[0] === "Facebook" && platforms[1] === "DV 360") {
            if ((facebookCheck.length > 0) && (dv360Check.length > 0)) {
              this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
            } else {
              this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
            }
          }

          if (platforms[0] === "ION" && platforms[1] === "DV 360") {
            if ((dv360Check.length > 0) && (ionCheck.length > 0)) {
              this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
            } else {
              this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
            }
          }

        } else if (platforms.length === 1) {
          platforms.forEach(item => {
            if (item === "Google Adwords") {
              if (googleCheck.length > 0) {
                this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
              } else {
                this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastStatus: "required", toastMsg: "" });
              }
            }

            if (item === "Facebook") {
              if (facebookCheck.length > 0) {
                this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
              } else {
                this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
              }
            }

            if (item === "DV 360") {
              if (dv360Check.length > 0) {
                this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
              } else {
                this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
              }
            }

            if (item === "ION") {
              if (ionCheck.length > 0) {
                this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
              } else {
                this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
              }
            }
          })
        }
      } else {
        this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required", errors, submited: true });
      }
    })
  };

  // ========= plaform payload function start here ======
  googlePayload = (val, action) => {
    var googlePayload = val.map(((item, index) => {
      if ((val[index].googleMasterAccountID != "") && (val[index].googleAdvertiserID != "") && (val[index].googleCurrency != "")) {
        return {
          masterAccountId: item.googleMasterAccountID,
          accountId: item.googleAdvertiserID,
          currency: item.googleCurrency,
          inex: 1
        }
      } else {
        return;
      }
    }))

    let googleFilter = googlePayload.filter(item => item != undefined);

    if (googleFilter.length > 0) {
      this.setState({
        googleCheck: [{
          platform: "Google Adwords",
          accountList: googleFilter,
        }],
      });
    }

  }

  facebookPayload = (val, action) => {
    if (action == "manual") {
      var facebookPayload = val.map((item => {
        return {
          accountId: item.fbAccountID,
          currency: item.fbCurrency,
          inex: 1
        }
      }));

      this.setState({
        facebookCheck: [{
          platform: "Facebook",
          accountList: facebookPayload,
        }],
      });
    } else if (action == "login") {
      var facebookPayload = val.map((item => {
        return {
          accountId: item.optionSelected.accId,
          currency: item.optionSelected.currency,
          inex: 1
        }
      }));

      this.setState({
        facebookCheck: [{
          platform: "Facebook",
          accountList: facebookPayload,
        }],
      });
    }

  }

  ionPayload = (val) => {
    var ionPayload = val.map((item => {
      return {
        accountId: item.ionAccountID,
        currency: item.ionCurrency,
        inex: 1
      }
    }));

    this.setState({
      ionCheck: [{
        platform: "ION",
        accountList: ionPayload,
      }],
    });
  }

  dv360Payload = (val) => {
    var dv360Payload = val.map((item => {
      return {
        accountId: item.dv360AccountID,
        currency: item.dv360Currency,
        inex: 1
      }
    }));

    this.setState({
      dv360Check: [{
        platform: "DV 360",
        accountList: dv360Payload,
      }],
    });
  }

  // ========= plaform payload function ends here ======
  Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  MultiValue = props => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );

  // ============ create advertiser platform ========
  createAdvertiser = async () => {
    const { form, googleCheck, facebookCheck, ionCheck, dv360Check } = this.state;
    const finalData = googleCheck.concat(facebookCheck, ionCheck, dv360Check);

    let createPayload = {
      advertisersPlatforms: [{
        advertiser: JSON.parse(localStorage.getItem("advertiserId")),
        inex: 1,
        platforms: finalData
      }]
    }

    const { tenantId, authToken, userId, createAdvertiserAction } =
      this.props;

    const { responseCode: { status = "", msg = "" } } = await createAdvertiserAction({
      tenantId,
      authToken,
      userId,
      payload: createPayload,
    });

    if (status == "Success") {
      // localStorage.removeItem("addType");
      localStorage.removeItem("googleAds");
      localStorage.removeItem("advertiserId");
      localStorage.removeItem("url");
      localStorage.removeItem("loginClicked");
      localStorage.removeItem("advertiserPlatform");
      this.toast(status, msg);
    } else if (status == "error" || status == "Failed" || status == "Fail" || status == "FAIL") {
      // localStorage.removeItem("addType");
      localStorage.removeItem("googleAds");
      localStorage.removeItem("advertiserId");
      localStorage.removeItem("url");
      localStorage.removeItem("loginClicked");
      localStorage.removeItem("advertiserPlatform");
      this.toast(status, msg, true);
    }
  }

  // ========== update advertiser platform =======
  updateAdvertiser = async () => {
    const { form, googleCheck, facebookCheck, ionCheck, dv360Check } = this.state;
    const finalData = googleCheck.concat(facebookCheck, ionCheck, dv360Check);


    let updatePayload = {
      advertisersPlatforms: [{
        advertiser: form.advertiserId,
        inex: 1,
        platforms: finalData
      }]
    }

    const { tenantId, authToken, userId, updateAdvertiserAction, history, match } =
      this.props;
    const {
      responseCode: { status = "", msg = "" },
      // responseList,
    } = await updateAdvertiserAction({
      tenantId,
      authToken,
      userId,
      payload: updatePayload
    });

    if (status) {
      this.toast(status, msg, false);
    }
  }

  // toast = (status, msg, redirect) => {
  //   this.setState({ enableToast: true, toastStatus: status, toastMsg: msg, redirectPage: redirect });
  //   return;
  // }

  async infoGenrateAccountID() {
    let editId = JSON.parse(localStorage.getItem("editId"));
    let payload = {
      advId: editId
    }



    const { tenantId, authToken, userId, getGenrateAccountIdDV360Action, history, match } =
      this.props;
    const {
      responseCode: { status = "", msg = "" },
      // responseList,
    } = await getGenrateAccountIdDV360Action({
      tenantId,
      authToken,
      userId,
      payload

    });

    if (status) {
      this.toast(status, msg, true);
    }



  }
  
  toast = (status, msg, redirect,isRedirectToAdvertiser=false) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg, redirectPage: redirect,isRedirectToList:isRedirectToAdvertiser });
    return;
  }

  confirmationCallbackModel = (check) => {
    // console.log("FFFFFFFFF");
    const editId = JSON.parse(localStorage.getItem("editId"));
    // this.setState({ enableToast: false }, () => {
    // if (editId) {
    //   this.updateAdvertiser();
    // } else {
    //   this.createAdvertiser();
    // }
    // });
    this.setState({ enableToast: false })
  }

  // handleToastStatus = (status, redirect) => {
  //   console.log("IIIIIIII");
  //   const { match: { params: id }, history } = this.props;
  //   this.setState({ enableToast: status, redirectPage: false, toastStatus: "", toastMsg: "" }, () => {
  //     if (redirect) {
  //       history.push('/' + routes.mainRoute + '/' + routes.containers.admin + '/' + routes.admin.advertiser.newAdvertiser);
  //     }
  //   });
  // }


  handleToastStatus = (status, redirect) => {
    // console.log("IIIIIIII");
    const {isRedirectToList} = this.state;
    const { match: { params: id }, history } = this.props;
    this.setState({ enableToast: status, redirectPage: false, toastStatus: "", toastMsg: "" }, () => {
      if (redirect || isRedirectToList) {
        history.push('/' + routes.mainRoute + '/' + routes.containers.admin + '/' + routes.admin.advertiser.newAdvertiser);
      }
    });
  }


  setSpinner=(spinnerValue)=>{
   this.setState({showSpinner:spinnerValue});
  }

  // // ========= edit manual accounts =======
  // editId = async (editId) => {
  //   const { match: { params: { id } }, tenantId, authToken, payload, userId, getEditListAdvertiserAction } = this.props;
  //   let { form } = this.state;
  //   let currency = '';
  //   if (editId) {
  //     let advertiserId = editId;
  //     const {
  //       responseCode: { status = "" },
  //       response,
  //     } = await getEditListAdvertiserAction({
  //       tenantId,
  //       authToken,
  //       userId,
  //       payload,
  //       advertiserId
  //     });
  //     if (status === "Success") {
  //       form.advertiserId = response.advertisersPlatforms[0].advertiser;

  //       this.setState({ editAdvertiserDetails: response.advertisersPlatforms[0] });

  //       const platformEdit = response.advertisersPlatforms.length > 0 && response.advertisersPlatforms[0].platforms;
  //       console.log("platformEdit", platformEdit);
  //       var obj = {
  //         facebookArr: [],
  //         googleArr: [],
  //         dvArr: [],
  //         ionArr: []
  //       }

  //       if (platformEdit.length > 0) {

  //         platformEdit.map(edit => {
  //           if (edit.platform === 'Facebook' && edit.accountList.length > 0) {
  //             obj.facebookArr = edit.accountList;
  //           }
  //           if (edit.platform === 'ION' && edit.accountList.length > 0) {
  //             obj.ionArr = edit.accountList;
  //           }
  //           if (edit.platform === 'Google Adwords' && edit.accountList.length > 0) {
  //             obj.googleArr = edit.accountList;
  //           }
  //           if (edit.platform === 'DV 360' && edit.accountList.length > 0) {
  //             form.addTypeDv360 = "0"
  //             obj.dvArr = edit.accountList;
  //           }

  //           platformtype.forEach((a) => {
  //             if (edit.accountList.length > 0 && edit.platform === a.value && a.checked === false) {
  //               a.checked = true;

  //               console.log("va", a.value);
  //             }
  //           })


  //         })

  //         console.log("platformtype", platformtype);

  //         var arr = [];
  //         platformtype.filter(item => item.checked === true ? arr.push(item.value) : "");

  //         form.platform = platformtype;

  //         this.setState({ form, selectedPlatform: arr, selectedPlatformObj: obj })
  //       }
  //     }
  //   }
  // };

    // ========= edit manual accounts =======
    editId = async (editId) => {
      const { match: { params: { id } }, tenantId, authToken, payload, userId, getEditListAdvertiserAction } = this.props;
      let { form } = this.state;
      let currency = '';
      if (editId) {
        let advertiserId = editId;
        const {
          responseCode: { status = "" },
          response,
        } = await getEditListAdvertiserAction({
          tenantId,
          authToken,
          userId,
          payload,
          advertiserId
        });
        if (status === "Success") {
          let platformEdit= [];
          let findDvPlatform = response.advertisersPlatforms.find((platform) => platform.platforms)
          let dvPlatform = findDvPlatform.platforms.find((checkPlatform) => checkPlatform.platform == "DV 360")
          this.setState({ editAdvertiserDetails: response.advertisersPlatforms[0] });
          if(response.advertisersPlatforms.length > 0){
            let findData = response.advertisersPlatforms.find((dataPlat)=>dataPlat.id == editId);
            if(findData){
              form.advertiserId = findData.advertiser ? findData.advertiser :" ";
              form.advId= findData.id ? findData.id : -1;
              platformEdit = findData.platforms ? findData.platforms : []
            }
          }
          var obj = {
            facebookArr: [],
            googleArr: [],
            dvArr: [],
            ionArr: []
          }

          console.log(platformEdit);
  
          if (platformEdit.length > 0) {
  
            platformEdit.map(edit => {
              if (edit.platform === 'Facebook' && edit.accountList.length > 0) {
                obj.facebookArr = edit.accountList;
              }
              if (edit.platform === 'ION' && edit.accountList.length > 0) {
                obj.ionArr = edit.accountList;
              }
              if (edit.platform === 'Google Adwords' && edit.accountList.length > 0) {
                obj.googleArr = edit.accountList;
              }
              if (edit.platform === 'DV 360' && edit.accountList.length > 0) {
                form.addTypeDv360 = "0"
                obj.dvArr = edit.accountList;
              }
              
              if (edit.platform === 'TikTok' && edit.accountList.length > 0) {
                obj.tiktokAccountData = edit.accountList;
              }

              platformtype.forEach((a) => {
                if (edit.accountList.length > 0 && edit.platform === a.value && a.checked === false) {
                  a.checked = true;
  
                }
              })
  
  
            })
  
            var arr = [];
            platformtype.filter(item => item.checked === true ? arr.push(item.value) : "");
  
            form.platform = platformtype;
  
            this.setState({ form, selectedPlatform: arr, selectedPlatformObj: obj, isAccountDV360: dvPlatform })
          }
        }
      }
    };

  render() {
    const { submited, errors, touched, form, advetiderListData, selectedPlatform, checkFields, enableToast,isAccountDV360,
      toastMsg,
      toastStatus,
      confirmationMsg, selectedPlatformObj, loginStatus,
      syncId, redirectPage,showSpinner } = this.state;


    const { match: { params: { id } } } = this.props;
    let advertiserId = JSON.parse(localStorage.getItem("advertiserId"));
    let editId = JSON.parse(localStorage.getItem("editId"));

    const RadioComponent = () => (
      <div>
        <h5 className='text-left mt-4 mb-3'>How Do You Like To Add</h5>
        <RadioBtn
          onChange={this.handleChange}
          onBlur={this.handleTouch}
          value={form[formFields.addTypeDv360.key]}
          setting={formFields[formFields.addTypeDv360.key]}
          error={errors[formFields.addTypeDv360.key]}
          submited={submited}
          touched={touched[formFields.addTypeDv360.key]}
          options={sortArray(formFields[formFields.addTypeDv360.key].options)}
        />
      </div>
    );
    

    return (
      <>
      {showSpinner && <Spinner />}
        {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            path={routes.containers.admin + '/' + routes.admin.advertiser.newAdvertiser}
            idProps={this.props}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            // redirect={redirectPage}
            poc={true}
          />
        }
        <div className="main-panel ion">
          <div className="content-wrapper">
            <BreadCrumb />
            <div className="row justify-content-center mt-4">
              <div className="col-md-10 grid-margin">
                <Card>
                  {
                    (editId) ? <div class="form-group row">

                      <label for="advertiserId" class="col-sm-3 col-form-label">Advertiser </label>
                      <div class="col-md-12">
                        <input value={form.advertiserId != undefined ? form.advertiserId : ''} disabled={editId ? true : false} className="input-disabled" />
                      </div>
                    </div> : (advertiserId != null) ? <div className='custom-test-select new'>
                      <label for="cars">Advertiser <span className='text-danger'>*</span></label>
                      <select name="advertiserId" onChange={this.handleChange} onBlur={this.handleTouch}>
                        <option value="Select">Select</option>
                        {advetiderListData != undefined &&
                          advetiderListData.map(option => option.value == advertiserId ?
                            <option value={option.value} selected>{option.value}</option> : <option value={option.value}>{option.value}</option>
                          )
                        }
                      </select>
                    </div> : <Select
                      onChange={this.handleChange}
                      onBlur={this.handleTouch}
                      value={form[formFields.advertiserId.key]}
                      setting={formFields[formFields.advertiserId.key]}
                      error={errors[formFields.advertiserId.key]}
                      submited={submited}
                      touched={touched[formFields.advertiserId.key]}
                      options={advetiderListData}
                      disabled={id ? true : false}
                    />
                  }
                  {
                    // form.advertiserId != "" ?
                    <CheckboxGroup
                      onChange={this.handleChange}
                      onBlur={this.handleTouch}
                      value={form[formFields.platform.key]}
                      setting={formFields[formFields.platform.key]}
                      error={errors[formFields.platform.key]}
                      submited={submited}
                      allowClear={true}
                      touched={touched[formFields.platform.key]}
                      options={platformtype}
                    />
                    // : ""
                  }
                  
                  
                  
                  <div class="accordion" id="accordionWithIcon">
                  {
                  selectedPlatform.map(item =>
                    item == "Google Adwords" ?
                  <div class="card accordion-item mb-2">
                    <h2 class="accordion-header d-flex align-items-center">
                      <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-1" aria-expanded="true">
                        <i class="ti ti-brand-google ti-xs me-2"></i>
                        Google Platform Login
                      </button>
                    </h2>

                    <div id="accordionWithIcon-1" class="accordion-collapse collapse show" >
                      <div class="accordion-body">
                      
                          <GoogleSignIn
                            options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                            paths={this.props}
                            handleCallback={this.googlePayload}
                            loginStatus={loginStatus}
                            googleEditData={selectedPlatformObj.googleArr}
                            syncId={syncId}
                            toast={this.toast}
                            editId={editId}
                            checkFields={checkFields}
                            advId= {form.advId ? form.advId : -1}
                            setSpinner={this.setSpinner}
                            {...this.props}
                          />
                        
                      </div>
                    </div>
                  </div>
                  :
                  item == "Facebook" ?
                  <div class="accordion-item card">
                    <h2 class="accordion-header d-flex align-items-center">
                      <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-2" aria-expanded="true">
                        <i class="ti ti-brand-facebook mr-2 ti-xs"></i>
                        Facebook Platform Login
                      </button>
                    </h2>
                    <div id="accordionWithIcon-2" class="accordion-collapse collapse show" >
                      <div class="accordion-body">
                    
                          <FacebookSignIn
                            options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                            paths={this.props}
                            handleCallback={this.facebookPayload}
                            facebookEditData={selectedPlatformObj.facebookArr}
                            editId={editId}
                            advId= {form.advId ? form.advId : -1}
                            {...this.props}
                            />
                       
                      </div>
                    </div>
                  </div>
                  :
                  item == "TikTok" ?
                  <div class="accordion-item card">
                    <h2 class="accordion-header d-flex align-items-center">
                      <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-5" aria-expanded="true">
                        <i class="ti ti-brand-tiktok mr-2 ti-xs"></i>
                        Tiktok Platform Login
                      </button>
                    </h2>
                    <div id="accordionWithIcon-5" class="accordion-collapse collapse show" >
                      <div class="accordion-body">
                    
                          <TiktokLogin
                           options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                            paths={this.props}
                            loginStatus={loginStatus}
                            tiktokEditData={selectedPlatformObj.tiktokAccountData ? selectedPlatformObj.tiktokAccountData:[]}
                            syncId={syncId}
                            editId={editId}
                            checkFields={checkFields}
                            advId= {form.advId ? form.advId : -1}
                            {...this.props}
                            />
                       
                      </div>
                    </div>
                  </div>
                  :
                  item == "ION" ?
                  <div class="accordion-item card">
                    <h2 class="accordion-header d-flex align-items-center">
                      <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-3" aria-expanded="true">
                        <i class="me-2 ti ti-ad ti-xs"></i>
                        ION Platform Login
                      </button>
                    </h2>
                    <div id="accordionWithIcon-3" class="accordion-collapse collapse show" >
                      <div class="accordion-body">
                          <h5 className='text-left'>ION Account 1</h5>
                          <h5 className='text-left mt-4 mb-3'>How Do You Like To Add</h5>
                            <RadioBtn
                              onChange={this.handleChange}
                              onBlur={this.handleTouch}
                              value={form[formFields.addTypeIon.key]}
                              setting={formFields[formFields.addTypeIon.key]}
                              error={errors[formFields.addTypeIon.key]}
                              submited={submited}
                              touched={touched[formFields.addTypeIon.key]}
                              options={sortArray((formFields[formFields.addTypeIon.key]).options)}
                            />
                            {
                              (form.addTypeIon == 0 && form.addTypeIon != "") ?
                                <IONPlatformLogin
                                  options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                                  paths={this.props}
                                  handleCallback={this.ionPayload}
                                  ionEditData={selectedPlatformObj.ionArr}
                                  editId={editId}
                                  {...this.props}
                                /> :
                                form.addTypeIon == 1 ?
                                  <ION
                                    paths={this.props}
                                    options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                                    checkFields={checkFields}
                                    handleCallback={this.ionPayload}
                                    ionEditData={selectedPlatformObj.ionArr}
                                    props={this.props}
                                    advId= {form.advId ? form.advId : -1}
                                  /> :
                                  ""
                            }
                      </div>
                    </div>
                  </div>
                  :
                  item == "DV 360" ? 

                  <div class="accordion-item card">
                    <h2 class="accordion-header d-flex align-items-center">
                      <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-4" aria-expanded="true">
                        <i class="me-2 ti ti-view-360 ti-xs"></i>
                        DV360 Platform Login
                      </button>
                    </h2>
                    <div id="accordionWithIcon-4" class="accordion-collapse collapse show" >
                      <div class="accordion-body">
                         
                      <h5 className='text-left'>DV360 Account</h5>

                      <Dv360SignIn
                         options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                         paths={this.props}
                         toast={this.toast}
                         dv360EditData={selectedPlatformObj.dvArr}
                         editId={editId}
                         isAccountDV360={isAccountDV360}
                         radioComponent={RadioComponent}
                                              checkFields={checkFields}
                                              handleCallback={this.dv360Payload}
                                              dvEditData={selectedPlatformObj.dvArr}
                                              infoGenrateAccountID={this.infoGenrateAccountID}
                         {...this.props}
                      />
                                      {/* {
                                        isAccountDV360 && isAccountDV360.accountList && isAccountDV360.accountList.length > 0 ?
                                          null
                                          :
                                          <RadioComponent />
                                      } */}
                                                       {/* {
                                        (form.addTypeDv360 == 0 && form.addTypeDv360 != "") ?
                                          <Dv360PlatformLogin
                                            options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                                            path={this.props}
                                            toast={this.toast}
                                            dv360EditData={selectedPlatformObj.dvArr}
                                            editId={editId}
                                            isAccountDV360={isAccountDV360}
                                            radioComponent={RadioComponent}
                                            
                                            {...this.props}
                                          />
                                          :
                                          form.addTypeDv360 == 1 ?
                                              <DV360
                                              options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                                              checkFields={checkFields}
                                              handleCallback={this.dv360Payload}
                                              toast={this.toast}
                                              editId={editId}
                                              dvEditData={selectedPlatformObj.dvArr}
                                              infoGenrateAccountID={this.infoGenrateAccountID}
                                              radioComponent={RadioComponent}
                                              isAccountDV360={isAccountDV360}
                                              path={this.props}
                                              {...this.props}
                                            />

                                            :
                                            ""
                                      } */}


                                    </div>
                                  </div>
                                </div>
                                :
                  item == "GAM" ?

                  <div class="accordion-item card">
                    <h2 class="accordion-header d-flex align-items-center">
                      <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-3" aria-expanded="false">
                        <i class="me-2 ti ti-ad-2 ti-xs"></i>
                        GAM Platform Login
                      </button>
                    </h2>
                    <div id="accordionWithIcon-3" class="accordion-collapse collapse" >
                      <div class="accordion-body">
                        <h5 className='text-left'>GAM Account</h5>
                        <h5 className='text-left mt-4 mb-3'>How Do You Like To Add</h5>
                        <RadioBtn
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFields.addTypeGam.key]}
                          setting={formFields[formFields.addTypeGam.key]}
                          error={errors[formFields.addTypeGam.key]}
                          submited={submited}
                          touched={touched[formFields.addTypeGam.key]}
                          options={sortArray((formFields[formFields.addTypeGam.key]).options)}
                        />
                        {
                          (form.addTypeGam == 0 && form.addTypeGam != "") ?
                            <GamPlatformLogin
                              options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                              path={this.props}
                            />
                            :
                            form.addTypeGam == 1 ?
                              <Gam
                                checkFields={checkFields}
                                handleCallback={this.dv360Payload}
                                dvEditData={selectedPlatformObj.dvArr}
                                props={this.props}
                              />
                              :
                              ""
                        }
                      </div>
                    </div>
                    
                  </div>
                  :
                  "")}
                  </div>


                  {/* {

                    selectedPlatform.map(item =>
                      item == "Google Adwords" ?
                        <>
                          <div className='main-class-wrap text-center'>
                            <GooglePlatformLogin
                              options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                              path={this.props}
                              handleCallback={this.googlePayload}
                              loginStatus={loginStatus}
                              googleEditData={selectedPlatformObj.googleArr}
                              syncId={syncId}
                              toast={this.toast}
                              editId={editId}
                              checkFields={checkFields}
                            />
                          </div>
                        </>
                        :
                        item == "Facebook" ?
                          <>
                            <div className='main-class-wrap text-center'>
                              <FacebookPlatformLogin
                                options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                                path={this.props}
                                handleCallback={this.facebookPayload}
                                facebookEditData={selectedPlatformObj.facebookArr}
                                editId={editId}
                                />
                            </div>
                          </>
                          :
                          item == "ION" ?
                            <div className='main-class-wrap text-center'>
                              <h5 className='text-left'>ION Account 1</h5>
                              <h5 className='text-left mt-4 mb-3'>How Do You Like To Add</h5>
                              <RadioBtn
                                onChange={this.handleChange}
                                onBlur={this.handleTouch}
                                value={form[formFields.addTypeIon.key]}
                                setting={formFields[formFields.addTypeIon.key]}
                                error={errors[formFields.addTypeIon.key]}
                                submited={submited}
                                touched={touched[formFields.addTypeIon.key]}
                                options={sortArray((formFields[formFields.addTypeIon.key]).options)}
                              />
                              {
                                (form.addTypeIon == 0 && form.addTypeIon != "") ?
                                  <IONPlatformLogin
                                    options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                                    path={this.props}
                                  /> :
                                  form.addTypeIon == 1 ?
                                    <ION
                                      checkFields={checkFields}
                                      handleCallback={this.ionPayload}
                                      ionEditData={selectedPlatformObj.ionArr}
                                      props={this.props}
                                    /> :
                                    ""
                              }
                            </div> :
                            item == "DV 360" ? <>
                              <div className='main-class-wrap text-center'>
                                <h5 className='text-left'>DV360 Account 1</h5>
                                <h5 className='text-left mt-4 mb-3'>How Do You Like To Add</h5>
                                <RadioBtn
                                  onChange={this.handleChange}
                                  onBlur={this.handleTouch}
                                  value={form[formFields.addTypeDv360.key]}
                                  setting={formFields[formFields.addTypeDv360.key]}
                                  error={errors[formFields.addTypeDv360.key]}
                                  submited={submited}
                                  touched={touched[formFields.addTypeDv360.key]}
                                  options={sortArray((formFields[formFields.addTypeDv360.key]).options)}
                                />
                                {
                                  (form.addTypeDv360 == 0 && form.addTypeDv360 != "") ?
                                    <Dv360PlatformLogin
                                      options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                                      path={this.props}
                                    />
                                    :
                                    form.addTypeDv360 == 1 ?
                                      <DV360
                                        checkFields={checkFields}
                                        handleCallback={this.dv360Payload}
                                        dvEditData={selectedPlatformObj.dvArr}
                                        props={this.props}
                                      />
                                      :
                                      ""
                                }
                              </div>
                            </> :
                              item == "GAM" ? <>
                                <div className='main-class-wrap text-center'>
                                  <h5 className='text-left'>GAM Account</h5>
                                  <h5 className='text-left mt-4 mb-3'>How Do You Like To Add</h5>
                                  <RadioBtn
                                    onChange={this.handleChange}
                                    onBlur={this.handleTouch}
                                    value={form[formFields.addTypeGam.key]}
                                    setting={formFields[formFields.addTypeGam.key]}
                                    error={errors[formFields.addTypeGam.key]}
                                    submited={submited}
                                    touched={touched[formFields.addTypeGam.key]}
                                    options={sortArray((formFields[formFields.addTypeGam.key]).options)}
                                  />
                                  {
                                    (form.addTypeGam == 0 && form.addTypeGam != "") ?
                                      <GamPlatformLogin
                                        options={{ accountOptions: accountOptions, optionFun: this.Option, multiValue: this.MultiValue }}
                                        path={this.props}
                                      />
                                      :
                                      form.addTypeGam == 1 ?
                                        <Gam
                                          checkFields={checkFields}
                                          handleCallback={this.dv360Payload}
                                          dvEditData={selectedPlatformObj.dvArr}
                                          props={this.props}
                                        />
                                        :
                                        ""
                                  }
                                </div>
                              </>
                                :
                                "")
                  } */}


                  <div className="form-group row mt-3">
                    <div className="col-sm-12">
                      <center>
                        {/* <button type="submit" onClick={(e) => this.handleSubmit(e)} className="btn btn-primary">Update</button> */}
                        {/* <button type="submit" onClick={(e) => this.handleSubmit(e)} className="btn btn-primary">Save</button> */}
                        <Link to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.advertiser.newAdvertiser}`}><button type="button" className="btn btn-secondary ml-3">Cancel</button></Link>
                      </center>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  state => ({
    configurationList: get(state, 'app.configurationData.responseList', []),
    ioAdvertisersReport: get(state, 'app.ioAdvertisersReport.responseList', []),
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    authToken: get(state, 'app.signInData.authToken', '')
  }),
  {
    updateAdvertiserAction,
    createAdvertiserAction,
    getAdvertisersWithoutAccounts,
    getEditListAdvertiserAction,
    getGenrateAccountIdDV360Action
  }
)(index);

// ----* IO propTypes * ----
index.propTypes = {
  addIoReportAction: PropTypes.func,
  getIoAdvertisersReportAction: PropTypes.func,
  configurationList: PropTypes.array,
  ioAdvertisersReport: PropTypes.array,
};